import i18n from '@/plugins/i18n'
import router from '@/router/'
import store from '@/store/'
import Layout from './Layout.vue'

let modalInstance = null
let callback = null

const eventBus = {
  events: {},

  $on(event, listener) {
    if (!this.events[event]) {
      this.events[event] = []
    }
    this.events[event].push(listener)
  },

  $emit(event, data) {
    if (this.events[event]) {
      this.events[event].forEach((listener) => listener(data))
    }
  },

  $off(event, listener) {
    if (this.events[event]) {
      this.events[event] = this.events[event].filter((l) => l !== listener)
    }
  },
}

const ModalPlugin = {
  install(Vue) {
    Vue.prototype.$Modal = {
      instance: null,
      parent: null,
      callback: null,
      bus: eventBus,
      async init(config = {}, vueInstance) {
        // If an instance of the modal already exists, return without creating a new one.
        if (modalInstance) {
          this.destroy()
        }

        // If a callback is provided, we store it.
        if (config.callback && typeof config.callback === 'function') {
          callback = config.callback
        }

        // Dynamically import the layout component if a name is provided
        const LayoutComponent = config.layout || Layout

        // Create and mount the modal instance.
        const ComponentClass = Vue.extend(LayoutComponent)
        modalInstance = new ComponentClass({
          propsData: config.propsData,
          router: router,
          store: store,
          i18n,
          destroyed: () => {
            modalInstance = null
          },
        })

        modalInstance.$mount()
        document.body.appendChild(modalInstance.$el)

        this.instance = modalInstance
        this.parent = vueInstance

        modalInstance.$on('modal:close', function (payload) {
          if (typeof callback === 'function') {
            callback(payload, vueInstance)
          }
        })
        modalInstance.$on('modal:open', function (payload) {
          if (typeof callback === 'function') {
            callback(payload, vueInstance)
          }
        })
      },
      destroy() {
        if (modalInstance && modalInstance.$el) {
          if (modalInstance?.$el) {
            modalInstance?.$el.remove()
          }
          modalInstance.$destroy()
        }
      },
    }
  },
}

export default ModalPlugin
